import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

const AppLayout = () => {
  let location = useLocation();

  return (
    <main className='overflow-hidden  w-screen h-screen'>
      <Outlet />
    </main>
  );
};

export default AppLayout;
